export function toCamelCaseFromSnakeCase(str: string) {
  const split = str.toLowerCase().split('_');
  let camelCaseStr = split[0];
  for (let i = 1; i < split.length; i++) {
    camelCaseStr += split[i].charAt(0).toUpperCase() + split[i].slice(1);
  }

  return camelCaseStr;
}
